import { createAction, props } from '@ngrx/store';

import { SystemUpgrade } from 'src/app/shared/services/ump';

import { Health } from './interface';

export const setIsLoading = createAction('[Global] Set isLoading', props<{ isLoading: boolean }>());

export const setPickupOffline = createAction(
  '[Global] Set PickupOffline',
  props<{ pickupOffline: boolean }>()
);

export const setPickupCodeOffline = createAction(
  '[Global] Set PickupCodeOffline',
  props<{ pickupCodeOffline: string }>()
);

export const loadHealth = createAction('[Health] Load health');

export const loadHealthSuccess = createAction(
  '[Health] Load health success',
  props<{ health: Health }>()
);

export const loadHealthFailure = createAction(
  '[Health] Load health failure',
  props<{ error: any }>()
);

export const setSessionActive = createAction(
  '[Session] Set Session Active',
  props<{ value: boolean }>()
);

export const loadSystemUpgrade = createAction('[SystemUpgrade] Load System Upgrade');

export const loadSystemUpgradeSuccess = createAction(
  '[SystemUpgrade] Load system upgrade success',
  props<{ systemUpgrade: SystemUpgrade }>()
);

export const loadSystemUpgradeFailure = createAction(
  '[SystemUpgrade] Load system upgrade failure',
  props<{ error: unknown }>()
);
